<template>
  <div class="ml-3 ml-md-0">
    <div>
      <section-title
        has-line
        content="El Plan de Acción de la ORE para atender la necesidad es:"
      />
      <validation-observer ref="formRef">
        <div class="bg-secondary-28 border-color--gray-5 p-3">
          <div class="row mb-4">
            <div class="col col-sm col-12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                mode="eager"
              >
                <custom-drop-down
                  v-model="formData.center"
                  label="Centro:"
                  placeholder="Seleccione"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.centers"
                  :disabled="
                    !isNewActionPlan ||
                      isReadOnly ||
                      catalog.centers.length == 1
                  "
                  :error="errors[0]"
                  custom-error-msg="El centro es requerido."
                  @input="handleSelectedCenter"
                />
              </validation-provider>
            </div>
            <div class="col col-sm col-12 mt-3 mt-md-0">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                mode="eager"
              >
                <custom-drop-down
                  v-model="formData.municipality"
                  label="Municipio:"
                  placeholder="Seleccione"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.municipalities"
                  :disabled="
                    !isNewActionPlan ||
                      isReadOnly ||
                      catalog.municipalities.length == 1
                  "
                  :error="errors[0]"
                  custom-error-msg="El municipio es requerido."
                  @input="handleSelectedMunicipality"
                />
              </validation-provider>
            </div>
            <div class="col col-sm col-12 mt-3 mt-md-0">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                mode="eager"
              >
                <custom-drop-down
                  v-model="formData.school"
                  label="Escuela:"
                  placeholder="Seleccione"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.schools"
                  :disabled="
                    !isNewActionPlan ||
                      isReadOnly ||
                      catalog.schools.length == 1
                  "
                  :error="errors[0]"
                  custom-error-msg="La escuela es requerida."
                />
              </validation-provider>
            </div>
          </div>
          <div class="mb-3">
            Para crear la alternativa de ubicación se identifica:
          </div>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            mode="eager"
          >
            <div class="d-flex align-items-center border-bottom">
              <div class="flex-grow-1">
                ¿Se utilizará el salón que se tiene a disposición?
                <custom-error
                  v-if="Boolean(errors[0])"
                  class="ml-n1"
                  message="Favor de seleccionar una opción."
                  variant="no-border"
                />
              </div>
              <custom-radio
                v-model="formData.venueAvailabilityStatusConfirmed"
                is-question-list
                class="ordered-header-card-custom-radio custom-radio__extended"
                custom-error-msg=""
                :name="'rbQuestion-1'"
                :disabled="isReadOnly"
                :options="rbOptions1"
                :change-event="handleChangeVenueAvailabilityStatusConfirmed"
              />
            </div>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            mode="eager"
          >
            <div class="d-flex align-items-center border-bottom">
              <div class="flex-grow-1">
                ¿Será atendido por el recurso humano asignado?
                <custom-error
                  v-if="Boolean(errors[0])"
                  class="ml-n1"
                  message="Favor de seleccionar una opción."
                  variant="no-border"
                />
              </div>
              <custom-radio
                v-model="formData.staffAssignmentResourceConfirmed"
                is-question-list
                class="ordered-header-card-custom-radio custom-radio__extended"
                custom-error-msg=""
                :name="'rbQuestion-2'"
                :disabled="isReadOnly"
                :options="rbOptions2"
                :change-event="handleChangeStaffAssignmentResourceConfirmed"
              />
            </div>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            mode="eager"
          >
            <div class="d-flex align-items-center border-bottom">
              <div class="flex-grow-1">
                ¿Se cuenta con los equipos y materiales necesarios?
                <custom-error
                  v-if="Boolean(errors[0])"
                  class="ml-n1"
                  message="Favor de seleccionar una opción."
                  variant="no-border"
                />
              </div>
              <custom-radio
                v-model="formData.equipmentMaterialsResourcesReady"
                is-question-list
                custom-error-msg=""
                class="ordered-header-card-custom-radio custom-radio__extended"
                :name="'rbQuestion-3'"
                :disabled="isReadOnly"
                :options="rbOptions3"
                :change-event="handleChangeEquipmentMaterialsResourcesReady"
              />
            </div>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            mode="eager"
          >
            <div class="d-flex align-items-center border-bottom">
              <div class="flex-grow-1">
                ¿La alternativa que está solicitando crear o modificar es preescolar?
                <custom-error
                  v-if="Boolean(errors[0])"
                  class="ml-n1"
                  message="Favor de seleccionar una opción."
                  variant="no-border"
                />
              </div>
              <custom-radio
                v-model="formData.isForPreschoolStudents"
                is-question-list
                custom-error-msg=""
                class="ordered-header-card-custom-radio custom-radio__extended"
                :name="'rbQuestion-4'"
                :disabled="isReadOnly"
                :options="rbOptions4"
                :change-event="handleChangeIsForPreschoolStudents"
              />
            </div>
          </validation-provider>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
// libs
import SectionTitle from 'SectionTitle';
import CustomRadio from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import CustomError from 'custom-error';

// services
import * as api from '@/views/pei/location-alternatives/_api';

// constants
const rbOptions = [
  {
    id: 1,
    label: 'Sí',
    value: '1',
    check: false,
  },
  {
    id: 2,
    label: 'En Proceso',
    value: '2',
    check: false,
  },
  {
    id: 3,
    label: 'No',
    value: '3',
    check: false,
  },
];

export default {
  name: 'OreActionPlan',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomRadio,
    CustomError,
  },
  props: {
    isNewActionPlan: {
      type: Boolean,
      default: false,
    },
    academicYearId: {
      type: Number,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        center: this.initialData.center,
        municipality: this.initialData.municipality,
        school: this.initialData.school,
        venueAvailabilityStatusConfirmed:
          this.initialData.venueAvailabilityStatusConfirmed || undefined,
        staffAssignmentResourceConfirmed:
          this.initialData.staffAssignmentResourceConfirmed || undefined,
        equipmentMaterialsResourcesReady:
          this.initialData.equipmentMaterialsResourcesReady || undefined,
        isForPreschoolStudents: this.initialData.isForPreschoolStudents || undefined,
      },
      rbOptions1: [
        ...rbOptions.map((option) => ({
          ...option,
          name: 'rbQuestion-1',
        })),
      ],
      rbOptions2: [
        ...rbOptions.map((option) => ({
          ...option,
          name: 'rbQuestion-2',
        })),
      ],
      rbOptions3: [
        ...rbOptions.map((option) => ({
          ...option,
          name: 'rbQuestion-3',
        })),
      ],
      rbOptions4: [
        ...rbOptions
          .filter(option => [1, 3].includes(option.id))
          .map(option => ({
            ...option,
            name: 'rbQuestion-4',
          })),
      ],
      catalog: {
        centers: [],
        municipalities: [],
        schools: [],
      },
    };
  },
  computed: {},
  watch: {
    initialData: {
      async handler(newVal) {
        this.formData.center = newVal.center;
        await this.handleSelectedCenter(newVal.center);
        this.formData.municipality = newVal.municipality;
        await this.handleSelectedMunicipality(newVal.municipality);
        this.formData.school = newVal.school;
        this.formData.venueAvailabilityStatusConfirmed =
          newVal.venueAvailabilityStatusConfirmed;
        this.formData.staffAssignmentResourceConfirmed =
          newVal.staffAssignmentResourceConfirmed;
        this.formData.equipmentMaterialsResourcesReady =
          newVal.equipmentMaterialsResourcesReady;
        this.formData.isForPreschoolStudents =
          newVal.isForPreschoolStudents;

        // set radio button checked
        if (newVal.venueAvailabilityStatusConfirmed) {
          const option = this.rbOptions1.find(
            (r) => r.value === newVal.venueAvailabilityStatusConfirmed
          );
          if (option) option.check = true;
        }
        if (newVal.staffAssignmentResourceConfirmed) {
          const option = this.rbOptions2.find(
            (r) => r.value === newVal.staffAssignmentResourceConfirmed
          );
          if (option) option.check = true;
        }
        if (newVal.equipmentMaterialsResourcesReady) {
          const option = this.rbOptions3.find(
            (r) => r.value === newVal.equipmentMaterialsResourcesReady
          );
          if (option) option.check = true;
        }
        if (newVal.isForPreschoolStudents) {
          const option = this.rbOptions4.find(
            (r) => r.value === newVal.isForPreschoolStudents
          );
          if (option) option.check = true;
        }
        this.resetForm();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchCenters();
  },
  methods: {
    async fetchCenters() {
      const data = await api.getCenters({
        academicYearId: this.academicYearId,
      });
      this.catalog.centers = data;
      if (data.length == 1) {
        this.formData.center = data[0];
        await this.fetchMunicipalities(data[0].id);
      }
    },
    async fetchMunicipalities(centerId) {
      const data = await api.getMunicipalities({
        academicYearId: this.academicYearId,
        centerId,
      });
      this.catalog.municipalities = data;
      if (data.length == 1) {
        this.formData.municipality = data[0];
        await this.fetchSchools(centerId, data[0].id);
      }
    },
    async fetchSchools(centerId, municipalityId) {
      const data = await api.getSchools({
        academicYearId: this.academicYearId,
        centerId,
        municipalityId,
      });
      this.catalog.schools = data;
      if (data.length == 1) {
        this.formData.school = data[0];
      }
    },
    async handleSelectedCenter(value) {
      this.formData.municipality = undefined;
      this.formData.school = undefined;
      this.catalog.municipalities = [];
      this.catalog.schools = [];
      if (value?.id) await this.fetchMunicipalities(value.id);
    },
    async handleSelectedMunicipality(value) {
      this.formData.school = undefined;
      this.catalog.schools = [];
      if (value?.id) {
        await this.fetchSchools(this.formData.center.id, value.id);
      }
    },
    handleChangeVenueAvailabilityStatusConfirmed(value) {
      this.formData.venueAvailabilityStatusConfirmed = value?.value;
    },
    handleChangeStaffAssignmentResourceConfirmed(value) {
      this.formData.staffAssignmentResourceConfirmed = value?.value;
    },
    handleChangeEquipmentMaterialsResourcesReady(value) {
      this.formData.equipmentMaterialsResourcesReady = value?.value;
    },
    handleChangeIsForPreschoolStudents(value) {
      this.formData.isForPreschoolStudents = value?.value;
    },
    async validateForm() {
      return await this.$refs.formRef.validate();
    },
    async resetForm() {
      this.$refs.formRef.reset();
    },
    getModel() {
      return { ...this.formData };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

::v-deep .custom-radio__extended {
  .custom-radio-container {
    > div {
      background: map-get($colors, 'white');
      &:has(.custom-radio-button.bg-green) {
        background: transparent;
      }

      &:first-child {
        border-radius: 5px 5px 0 0 !important;
      }
      &:nth-child(2) {
        border-radius: 0px !important;
        .custom-radio-button {
          &.bg-green {
            border-radius: 0px !important;
          }
        }
      }
      &:last-child {
        border-radius: 5px 5px 0 0 !important;
      }
    }
    .custom-radio-button {
      border-radius: 0 !important;
      width: 92px !important;
      height: 70px !important;
      flex-shrink: 0 !important;
      .step-label {
        font-size: 12px !important;
      }
    }
    .custom-radio-button {
      &.bg-green {
        background-color: map-get($colors, 'primary-1') !important;
      }
    }
  }
}

.custom-radio-button {
  &.bg-gray {
    background-color: #fff !important;
  }
  &.bg-green {
    background-color: map-get($colors, 'primary-1') !important;
  }
}
</style>
